<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li v-if="showRegaValidation" class="mx-3 breadcrumb-title" @click.prevent="prevStep" aria-current="page">
          {{$t("nav.realEstateServices")}}
        </li>
        <li v-else class="active mx-3 almarai-bold mouse-hand" aria-current="page" @click.prevent="prevDocument">
          {{$t("nav.realEstateServices")}}
        </li>
        <li v-if="step =='documentation'" class="active almarai-bold" aria-current="page">
          <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
          <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
          <span class="mx-2"> {{$t("addAd.title_80")}} </span>
        </li>
      </ol>
    </nav>
  </div>
  <div class="container realEstateServices" v-if="!ISLOADING">
    <div class="row" v-if="form == 1 && !showRegaValidation">
      <div class="col">
        <!-- <h5 class="font-24 almarai-bold py-2">إضـافـة إعــلان</h5> -->
        <div class="row Advertisement">
          <div v-if="GET_USER" class="col-12 col-md-5 advert" @click.prevent="validationForm('owner')">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/Owner_Agent.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">
                      {{$t("addAd.ownerOrBroker")}}
                      <div class="bg-text">{{$t("addAd.free")}}</div>
                    </div>
                    <div class="p-content">{{$t("addAd.owner_Agent_P")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-12 col-md-5 advert">
            <div class="card" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/Owner_Agent.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">
                      {{$t("addAd.ownerOrBroker")}}
                      <div class="bg-text">{{$t("addAd.free")}}</div>
                    </div>
                    <div class="p-content">{{$t("addAd.owner_Agent_P")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--begin:business_Transfer -->
          <div class="col-12 col-md-5 advert" v-if="GET_USER">
            <router-link to="/businessproject">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto button-center">
                      <img src="/assets/images/icons/Frame-2-4.png" class="width-48" alt="">
                    </div>
                    <div class="col p-0">
                      <div class="almarai-bold">
                        {{$t("addAd.title_81")}} 
                        <div class="bg-text">{{$t("addAd.sellingBusiness")}}</div>
                      </div>
                      <div class="p-content">{{$t("addAd.title_82")}}</div>
                    </div>
                    <div class="col-auto button-center">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div v-else class="col-12 col-md-5 advert">
            <div class="card" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/Frame-2-4.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">
                      {{$t("addAd.title_81")}} 
                      <div class="bg-text">{{$t("addAd.free")}}</div>
                    </div>
                    <div class="p-content">{{$t("addAd.title_82")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end:business_Transfer -->

          <!--begin: Licensed Broker Advertisement-->

          <!-- <div class="col-12 col-md-5">
            <div class="card" @click.prevent="validationForm('broker')">
              <div class="card-body ">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/Broker.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">
                      {{$t("addAd.title_4")}}
                      <div class="bg-text">{{$t("addAd.free")}}</div>
                    </div>
                    <p class="p-content">{{$t("addAd.brokers_P")}}</p>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div class="row businessTransfer Advertisement">
          <!--begin:business_Transfer -->
          <div class="col-12 col-md-5 advert" v-if="GET_USER">
            <div class="card document-style" @click.prevent="documentationFN">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/documention.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">{{$t("addAd.title_7")}}</div>
                    <div class="p-content">{{$t("addAd.title_8")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-12 col-md-5 advert">
            <div class="card document-style" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/documention.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">{{$t("addAd.title_7")}}</div>
                    <div class="p-content">{{$t("addAd.title_8")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <!--end:business_Transfer -->

          <!-- begin:photography -->
          <div class="col-12 col-md-5 mouse-hand advert" v-if="GET_USER">
            <router-link to="/photography">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto button-center">
                      <img src="/assets/images/icons/Frame-2-5.png" class="width-48" alt="">
                    </div>
                    <div class="col p-0">
                      <div class="almarai-bold">{{$t("addAd.title_83")}}</div>
                      <div class="p-content">{{$t("addAd.title_84")}}</div>
                    </div>
                    <div class="col-auto button-center">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div v-else class="col-12 col-md-5 mouse-hand advert">
            <div class="card" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto button-center">
                    <img src="/assets/images/icons/Frame-2-5.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0">
                    <div class="almarai-bold">{{$t("addAd.title_83")}}</div>
                    <div class="p-content">{{$t("addAd.title_84")}}</div>
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end:photography -->
        </div>
        <div class="row businessTransfer Advertisement">
          <!-- begin lawyerRequest -->
          <div class="col-12 col-md-5 advert" v-if="GET_USER">
            <router-link to="/lawyer">
              <div class="card lawyer">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto content-center">
                      <img src="/assets/images/icons/lawyer-icon.png" class="width-48" alt="">
                    </div>
                    <div class="col p-0 content-center">
                      <div class="almarai-bold">{{$t('contactLawyer')}}</div>
                      <div class="p-content">{{$t('DiscussLegal')}}</div>
                      <!-- <div> 
                        <span class="gray-color">{{$t('lawyerNow')}}</span>
                        <span class="mx-2 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                        <span class="green-color-F icon-saudi_riyal_bold_new"></span> 
                      </div> -->
                    </div>
                    <div class="col-auto button-center">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-12 col-md-5 advert" v-else>
            <div class="card lawyer" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto content-center">
                    <img src="/assets/images/icons/lawyer-icon.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0 content-center">
                    <div class="almarai-bold">{{$t('contactLawyer')}}</div>
                    <div class="p-content">{{$t('DiscussLegal')}}</div>
                    <!-- <div> 
                      <span class="gray-color">{{$t('lawyerNow')}}</span>
                      <span class="mx-2 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                      <span class="green-color-F icon-saudi_riyal_bold_new"></span> 
                    </div> -->
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end lawyerRequest -->

          <!-- begin:Issuing an advertising license -->
          <div class="col-12 col-md-5 advert" v-if="GET_USER">
            <router-link to="/advertisingLicense">
              <div class="card lawyer">
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto content-center">
                      <img src="/assets/images/icons/advertising-icon.png" class="width-48" alt="">
                    </div>
                    <div class="col p-0 content-center">
                      <div class="almarai-bold">{{$t('addAd.advertisingLicense')}}</div>
                      <div class="p-content">{{$t('addAd.submitRequest')}}</div>
                      <!-- <div> 
                        <span class="gray-color">{{$t('lawyerNow')}}</span>
                        <span class="mx-2 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                        <span class="green-color-F icon-saudi_riyal_bold_new"></span> 
                      </div> -->
                    </div>
                    <div class="col-auto button-center">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-12 col-md-5 advert" v-else>
            <div class="card lawyer" @click.prevent="poupLogin">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto content-center">
                    <img src="/assets/images/icons/advertising-icon.png" class="width-48" alt="">
                  </div>
                  <div class="col p-0 content-center">
                    <div class="almarai-bold">{{$t('addAd.advertisingLicense')}}</div>
                    <div class="p-content">{{$t('addAd.submitRequest')}}</div>
                    <!-- <div> 
                      <span class="gray-color">{{$t('lawyerNow')}}</span>
                      <span class="mx-2 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                      <span class="green-color-F icon-saudi_riyal_bold_new"></span> 
                    </div> -->
                  </div>
                  <div class="col-auto button-center">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                    <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end:Issuing an advertising license -->
        </div>
      </div>
    </div>
    <!-- <div v-if="hasError" class="text-center">
      <errorAlert :alertMessage="message" />
    </div> -->

    <div v-if="form == 1 && showRegaValidation" class="row">
      <div class="col">
        <!-- <div class="row">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link></li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="mx-3 breadcrumb-title" @click.prevent="prevStep" aria-current="page">
                  {{$t("nav.realEstateServices")}}
                </li>
              </ol>
            </nav>
          </div>
        </div> -->
        <div class="row pt-3 justify-content-center">
          <div class="col">
            <errorAlert v-if="checkerError" :alertMessage="message" :errorNumber="errorNumber" />
            <div class="row justify-content-center">
              <div class="col-12 col-sm-6 mb-3">
                <label class="form-label">{{ $t('addAd.title_26') }}:</label>
                <input type="text" class="form-control input-style" v-model="adLicenseNumber" />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-12 col-sm-6 mb-3">
                <label class="form-label">{{ $t('addAd.idType') }}:</label>
                <select v-model="idType" class="form-control input-style">
                  <option :value="null">{{ $t('addAd.idTypeSelect') }}</option>
                  <option value="1">{{ $t('addAd.idTypePersonal') }}</option>
                  <option value="2">{{ $t('addAd.idTypeCompany') }}</option>
                </select>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-12 col-sm-6 mb-3">
                <label class="form-label">{{ $t('addAd.advertiserId') }}:</label>
                <input type="text" class="form-control input-style" v-model="advertiserId" />
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-9 col-md-3 btn-green text-center">
                <div :disabled="checkerDisabled" @click.prevent="checkLicense">{{ $t('addAd.title_34') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin:add Real Estate-->
    <div v-if="form == 2" class="row full-padding justify-content-center">
      <div class="col">
        <div class="row">
          <div class="col">
            <!-- <span class="mouse-hand" @click.prevent="prevStep"> 
              <i class="fa-solid fa-arrow-right"></i>
            </span>
            <div>
              <h5 class="py-2 font-24 almarai-bold">{{$t('addAd.title_9')}}</h5>
            </div> -->
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link></li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="mx-3 breadcrumb-title" @click.prevent="prevStep" aria-current="page">
                  {{$t("nav.realEstateServices")}}
                </li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="active mx-3 almarai-bold" aria-current="page">
                  {{$t("addAd.title_86")}}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="card input-style bg-card">
              <div class="card-body p-1">
                <div class="row">
                  <div class="col text-center" @click.prevent="ownerFN">
                    <div :class="(ownerType == 'owner') ? 'form-control input-style bg-button bg-shadow': 'form-control input-style bg-button'" >
                      {{$t('addAd.title_17')}}
                    </div>
                  </div>
                  <div class="col text-center" @click.prevent="agentFN">
                    <div :class="(ownerType == 'agent') ? 'form-control input-style bg-button bg-shadow ': 'form-control input-style bg-button'">
                      {{$t('addAd.title_18')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="ErrorAlert">
        <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
      </div>
      <div class="row py-5 justify-content-center">
        <div class="col">
          <!-- begin:form owner -->
          <div class="row" v-if="ownerType == 'owner'">
            <div class="col-12 col-md-6 pb-2">
              <label for="" class="p-content" >{{$t('addAd.receiptImage')}}</label>
              <input type="file" class="form-control input-style" @change="setReceiptImage($event.target.files)" multiple>
            </div>

            <div v-if="!receiptNumberDisabled" class="col-12 col-md-6 pb-2">
              <label class="p-content" for="">{{$t('addAd.title_12')}} <span class="stars">*</span></label>
              <input type="text" maxlength="16" @input="receiptNumber = receiptNumber.replace(/[^0-9]/g, '')"
                class="form-control input-style" v-model="receiptNumber" :disabled="receiptNumberDisabled"
              >
              <div class="error-feedback red-color fonttext-14" v-if="V$.receiptNumber.$error">
                {{ validateMessage }}
              </div>
            </div>

            <!-- <div class="col-12 col-md-6 pb-2">
              <label class="p-content" for="">{{$t('addAd.title_15')}}</label>
              <datepicker class="form-control input-style mouse-hand"
                v-model="receiptDate"
                :clearable="true"
                :upperLimit="yesterday"
              />
            </div> -->

            <div v-if="!ownerIdentityDisabled" class="col-12 col-md-6 pb-2">
              <label class="p-content" for="">{{$t('addAd.title_10')}} <span class="stars">*</span></label>
              <input type="text" class="form-control input-style"
                v-model="baiscOwner.ownerIdentity" :disabled="ownerIdentityDisabled" maxlength="10"
                @input="baiscOwner.ownerIdentity = baiscOwner.ownerIdentity.replace(/[^0-9]/g, '')"
              >
              <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerIdentity.$error">
                {{ validateMessage }}
              </div>
            </div>
            <div class="col-12 col-md-6 pb-2 position-R">
              <label class="p-content" for="">{{$t('addAd.title_11')}} <span class="stars">*</span></label>
              <datepicker class="form-control input-style mouse-hand"
                v-model="baiscOwner.ownerDOB"
                :clearable="true"
                :upperLimit="maxDate"
              />
              <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerDOB.$error">
                {{ validateMessage }}
              </div>
            </div>
            
            <div v-if="!ownerPhoneDisabled" class="col-12 col-md-6 pb-2" id="ownerMobile">
              <label class="p-content" for="">{{$t('addAd.title_13')}} <span class="stars">*</span></label>
              <input type="text" maxlength="10"  
                class="form-control input-style" v-model="baiscOwner.ownerPhone" :disabled="ownerPhoneDisabled"
                @input="baiscOwner.ownerPhone = baiscOwner.ownerPhone.replace(/[^0-9]/g, '')"
              >
              <!-- <p v-if="error" style="color: red;">
                {{$t('incorrectMobile')}}
              </p> -->
              <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerPhone.$error">
                {{ validateMessage }}
              </div>
            </div>

          </div>
          <!--end:form owner -->

          <!--begin:form agent-->
          <div class="row" v-if="ownerType == 'agent'">
            <div class="col">
              <div class="row py-3 justify-content-center">
                <div class="col-12 col-md-12">
                  <div class="text-center" v-if="agentError">
                    <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <div class="col-12 col-md-6 pb-2">
                  <label for="" class="p-content" >{{$t('addAd.title_14')}}</label>
                  <input type="file" class="form-control input-style" @change="uploadFile($event.target.files)" placeholder="ارفع صور الصك">
                </div> -->
                <div class="col-12 col-md-6 pb-2">
                  <label for="" class="p-content" >{{$t('addAd.agencyPhoto')}}</label>
                  <input type="file" class="form-control input-style" @change="uploadFile($event.target.files)" placeholder="ارفع صور الوكالة" multiple>
                </div>

                <div v-if="!agencyNumberDisabled" class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_21')}} <span class="stars">*</span></label>
                  <input type="text" class="form-control input-style" v-model="baiscAgent.agencyNumber" :disabled="agencyNumberDisabled"
                    maxlength="10" @input="baiscAgent.agencyNumber = baiscAgent.agencyNumber.replace(/[^0-9]/g, '')"
                  >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agencyNumber.$error">
                    {{ validateMessage }}
                  </div>
                </div>

                <div v-if="!receiptNumberDisabled" class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_12')}} <span class="stars">*</span></label>
                  <input type="text" class="form-control input-style" v-model="receiptNumber" :disabled="receiptNumberDisabled"
                    maxlength="16" @input="receiptNumber = receiptNumber.replace(/[^0-9]/g, '')"
                  >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.receiptNumber.$error">
                    {{ validateMessage }}
                  </div>
                </div>

                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_15')}}</label>
                  <datepicker class="form-control input-style mouse-hand"
                    v-model="receiptDate"
                    :clearable="true"
                    :upperLimit="today"
                    @update:modelValue="onChange"
                  />
                </div> -->

                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_10')}} <span class="stars">*</span></label>
                  <input type="text" class="form-control input-style" v-model="baiscAgent.ownerIdentity"
                    maxlength="10" @input="baiscAgent.ownerIdentity = baiscAgent.ownerIdentity.replace(/[^0-9]/g, '')"
                  >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.ownerIdentity.$error">
                    {{ validateMessage }}
                  </div>
                </div> -->

                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_11')}} <span class="stars">*</span></label>
                  <datepicker class="form-control input-style mouse-hand"
                    v-model="baiscAgent.ownerDOB"
                    :upperLimit="maxDate"
                    :clearable="true"
                  />
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.ownerDOB.$error">
                    {{ validateMessage }}
                  </div>
                </div> -->

                <div v-if="!agentIdentityDisabled" class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_19')}} <span class="stars">*</span></label>
                  <input type="text" class="form-control input-style" v-model="baiscAgent.agentIdentity" :disabled="agentIdentityDisabled"
                    maxlength="10" @input="baiscAgent.agentIdentity = baiscAgent.agentIdentity.replace(/[^0-9]/g, '')"
                  >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentIdentity.$error">
                    {{ validateMessage }}
                  </div>
                </div>

                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_22')}}</label>
                  <datepicker class="form-control input-style mouse-hand"
                    v-model="agencyDate"
                    :clearable="true"
                    :upperLimit="maxDate"
                  />
                </div> -->

                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_20')}} <span class="stars">*</span></label>
                  <datepicker class="form-control input-style mouse-hand"
                    v-model="baiscAgent.agentDOB"
                    :clearable="true"
                    :upperLimit="maxDateAgent"
                  />
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentDOB.$error">
                    {{ validateMessage }}
                  </div>
                </div> -->

                <div v-if="!agentMobileDisabled" class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('addAd.title_23')}} <span class="stars">*</span></label>
                  <input type="text" class="form-control input-style" v-model="baiscAgent.agentMobile" :disabled="agentMobileDisabled"
                    maxlength="10" @input="baiscAgent.agentMobile = baiscAgent.agentMobile.replace(/[^0-9]/g, '')"
                  >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentMobile.$error">
                    {{ validateMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end:form agent-->
          <div class="row pt-5 justify-content-center">
            <div class="col-11 col-md-5 text-center mouse-hand">
              <div @click.prevent="nextStep" class="login-btn padding-style form-control almarai-bold" >{{$t('addAd.title_16')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:add Real Estate-->

    <!--begin:broker Advertisement-->
    <div class="row full-padding" v-if="form == 'brokerAd'">
      <div class="col">
        <div class="row">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3">
                  <router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link>
                </li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="mx-3 breadcrumb-title" @click.prevent="prevStep" aria-current="page">
                  <!-- {{$t("addAd.breadcrumb_2")}} -->
                  {{$t("nav.realEstateServices")}}
                </li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
                <li class="active mx-3 almarai-bold" aria-current="page">
                  {{$t("addAd.title_24")}}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row justify-content-center pt-4">
          <div class="col-12 col-md-12">
            <errorAlert v-if="brokerError" :alertMessage="message" :errorNumber="errorNumber" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content"  >{{$t('addAd.title_25')}} <span class="stars">*</span></label>
            <input type="text" v-model="broker.falLicense" class="form-control input-style" :placeholder="$t('addAd.title_27')"
              maxlength="12" @input="broker.falLicense = broker.falLicense.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.falLicense.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_26')}} <span class="stars">*</span></label>
            <input type="text" v-model="broker.adLicenseNumber" :disabled="true" class="form-control input-style" :placeholder="$t('addAd.title_29')"
              maxlength="12" @input="broker.adLicenseNumber = broker.adLicenseNumber.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.adLicenseNumber.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div class="col-12 col-md-6 pb-2">
            <label for="" class="p-content" >{{$t('addAd.receiptImage')}}</label>
            <input type="file" class="form-control input-style" @change="setReceiptImage($event.target.files)" multiple>
          </div>

          <div v-if="!receiptNumberDisabled" class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_12')}} <span class="stars">*</span></label>
            <input type="text" maxlength="16" @input="receiptNumber = receiptNumber.replace(/[^0-9]/g, '')"
              v-model="receiptNumber" :disabled="receiptNumberDisabled" class="form-control input-style" :placeholder="$t('addAd.title_28')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.receiptNumber.$error">
              {{ validateMessage }}
            </div>
          </div>

          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_15')}}</label>
            <datepicker class="form-control input-style mouse-hand"
              v-model="receiptDate"
              :clearable="true"
              :upperLimit="today"
              @update:modelValue="onChange"
            />
          </div> -->

          <!-- <div class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_10')}} <span class="stars">*</span></label>
            <input type="text" class="form-control input-style" v-model="broker.ownerIdentity"
              maxlength="10" @input="broker.ownerIdentity = broker.ownerIdentity.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.ownerIdentity.$error">
              {{ validateMessage }}
            </div>
          </div> -->

          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_11')}} <span class="stars">*</span></label>
            <datepicker class="form-control input-style mouse-hand"
              v-model="broker.ownerDOB"
              :clearable="true"
              :upperLimit="maxDate"
            />
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.ownerDOB.$error">
              {{ validateMessage }}
            </div>
          </div> -->
          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_13')}} <span class="stars">*</span></label>
            <input type="text" v-model="broker.ownerPhone" class="form-control input-style" :placeholder="$t('addAd.title_30')"
              maxlength="10" @input="broker.ownerPhone = broker.ownerPhone.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.ownerPhone.$error">
              {{ validateMessage }}
            </div>
          </div> -->

          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content" >{{$t('addAd.title_19')}} <span class="stars">*</span></label>
            <input type="text" v-model="broker.agentIdentity" class="form-control input-style" :placeholder="$t('addAd.title_31')"
              maxlength="10" @input="broker.agentIdentity = broker.agentIdentity.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentIdentity.$error">
              {{ validateMessage }}
            </div>
          </div> -->

          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content">{{$t('addAd.title_21')}}<span class="stars">*</span></label>
            <input type="text" v-model="broker.agencyNumber" class="form-control input-style" :placeholder="$t('addAd.title_32')"
              maxlength="10" @input="broker.agencyNumber = broker.agencyNumber.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agencyNumber.$error">
              {{ validateMessage }}
            </div>
          </div> -->
          <!-- <div class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content">{{$t('addAd.title_20')}} <span class="stars">*</span></label>
            <datepicker class="form-control input-style mouse-hand"
              v-model="broker.agentDOB"
              :clearable="true"
              :upperLimit="maxDateAgent"
            />
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentDOB.$error">
              {{ validateMessage }}
            </div>
          </div> -->
          <div v-if="!agentMobileDisabled" class="col-12 col-md-6 pb-2 mb-3">
            <label for="" class="p-content">{{$t('addAd.brokerNumber')}} <span class="stars">*</span></label>
            <input type="text" v-model="broker.agentMobile" :disabled="agentMobileDisabled" class="form-control input-style" :placeholder="$t('addAd.enterBrokerNumber')"
              maxlength="10" @input="broker.agentMobile = broker.agentMobile.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentMobile.$error">
              {{ validateMessage }}
            </div>
          </div>
        </div>
        <div class="row pt-4 justify-content-center">
          <div class="col-11 col-md-5 mouse-hand text-center">
            <div @click="nextStep" class="btn-green">{{$t('addAd.title_34')}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--end: broker Advertisement -->

    <!--begin: Property documentation-->
    <div class="row" v-if="step == 'documentation'">
      <div class="col">
        <div class="row">
          <div class="col">
            <!-- <span class="mouse-hand" @click.prevent="prevDocument"> 
              <i class="fa-solid fa-arrow-right"></i>
            </span> -->
            <!-- <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link></li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left breadcrumb-icon"></i>
                <i  v-else class="fa-solid fa-chevron-right breadcrumb-icon"></i>
                <li class="mx-3 almarai-bold mouse-hand" >
                  {{$t("nav.realEstateServices")}}
                </li>
                <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left breadcrumb-icon"></i>
                <i  v-else class="fa-solid fa-chevron-right breadcrumb-icon"></i>
                
              </ol>
            </nav> -->
            <!-- <div>
              <h5 class="py-2 font-24 almarai-bold">{{$t('addAd.title_35')}}</h5>
            </div> -->
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-8 text-center">
            <div v-if="alertSuccess" class="text-center">
              <success :message="successMessage" />
            </div>
          </div>
        </div>
        <div v-if="hasError" class="text-center">
          <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-8">
            <div class="card border-0">
              <div class="card-body">
                <form id='myForm'>
                  <div class="row justify-content-center">
                    <div class="col-12 pb-2 mb-2 position-R">
                      <label for="" class="p-content" >{{$t('addAd.title_36')}} <span class="stars">*</span></label>
                      <input type="text" maxlength="50" v-model="fullName" class="form-control input-style" 
                        :placeholder="$t('addAd.title_39')" @keypress="charsOnly"
                      >
                      <!-- <i class="fa-solid fa-id-card form-icons"></i> -->
                      <div class="error-feedback red-color fonttext-14" v-if="V$.fullName.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 pb-2 mb-2 position-R">
                      <label for="" class="p-content">{{$t('addAd.title_37')}} <span class="stars">*</span></label>
                      <input type="text" maxlength="10" v-model="mobile" 
                        class="form-control input-style" :placeholder="$t('addAd.title_40')"
                        @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      >
                      <!-- <i class="fa-solid fa-mobile-screen-button form-icons"></i> -->
                      <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                  </div>

                  <div v-for="(row,index) in options" :key="index" :class="(packageId == row.id)? 'col-12 priceList input-style mb-3' : 'col-12 input-style mb-3'">
                    <label class="d-block  mouse-hand" :for="row.id">
                      <div class="row">
                        <div class="col content-center">
                          <input class="form-check-input radio" v-model="packageId" @change="selectedPackage" type="radio" :value="row.id" name="radioDefault" :id="row.id">
                          <span class="mx-2 almarai-bold">{{row.name}}</span>
                        </div>
                        <div class="col-auto">
                          <div class="text-end me-auto almarai-bold">{{row.price}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span></div>
                        </div>
                      </div>
                    </label>
                  </div>
                  <div class="error-feedback red-color fonttext-14" v-if="V$.packageId.$error">
                    {{ validateMessage }}
                  </div>

                  <div class="row">
                    <div class="col position-R">
                      <label class="p-content">{{$t('maintenances.title_9')}}</label>
                      <input type="text" id="discount" class="form-control input-style" v-model="discount">
                      <span class="discount_Photo" @click.prevent="checkDiscount">{{$t('maintenances.title_10')}}</span>
                    </div>
                  </div>

                  <div class="row py-5 justify-content-center">
                    <div  class="col-10 col-md-5">
                      <!-- <div v-if="documentLoading" class="text-center">
                        <loader  />
                      </div> -->
                      <div @click.prevent="showPayment" class="btn-green" >{{$t('addAd.title_38')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--end: Property documentation-->
    <!--begin:form success-->
    <div class="row" v-if="step == 'formSuccess'">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="img-fluid" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('request_submitted')}}</h4>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-11 col-md-6 text-center">
            <router-link to="/">
              <div class="btn-green">{{$t('formSuccess.title_4')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!--begin:Property Data Add-->
    <div class="row" v-if="form == 3">
      <div class="col">
        <div class="row">
          <div class="col">
            <!-- <span class="mouse-hand" @click.prevent="prevStep">
              <i class="fa-solid fa-arrow-right"></i>
            </span> -->
            <div class="py-2">
              <h5>{{$t('addAd.title_41')}}</h5>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_53')}} <span class="stars">*</span></label>
            <input type="text" v-model="propertyAdd.title" class="form-control input-style"
              maxlength="50"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.title.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div class="col-12 col-md-6 pb-2">
            <label class="p-content"  for="">{{$t('addAd.title_54')}} <span class="stars">*</span></label>
            <textarea id="des"  v-model="propertyAdd.description" class="form-control" rows="2">
            </textarea>
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.description.$error">
              {{ validateMessage }}
            </div>
          </div>
        </div>
        <div class="row py-2">
          <div class="col-12 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_56')}}</label>
            <input type="file" v-if="!mediaLoader" class="form-control input-style" @change="uploadMedia($event.target.files)" multiple>
            <!--begin mediaLoader-->
            <div v-if="mediaLoader" class="text-center"><loader /></div>
            <!--end mediaLoader-->
            <div class="row">
              <div class="col-auto my-2" v-for="(img, indx) in mediaList" :key="indx">
                <div class="position-R" @click.prevent="deleteImg(img.id, indx)" >
                  <i class="bi bi-trash delete-icon red-color mouse-hand"></i>
                </div>
                <img :src="MEDIA_URL+img.path" style="max-width: 160px;" alt="">
              </div>
            </div>
          </div>
        </div>
        <div v-if="!categoryDisabled" class="row py-2">
          <span class="p-content py-2">{{$t('addAd.title_42')}} <span class="stars">*</span> </span>
          <div class="col-auto">
            <label class="form-check-label mouse-hand" for="flexRadio">
              <div :class="(propertyAdd.category == 'commercial')? 'form-check rounded-pill classification-b button-bg':'form-check rounded-pill classification-b'">
                <input type="radio" class="form-check-input d-none" @change="getTypes" required v-model="propertyAdd.category" :disabled="categoryDisabled" value="commercial" id="flexRadio" name="flexn">
                <span>{{$t('addAd.title_43')}}</span>
              </div>
            </label>
          </div>
          <div class="col-auto mouse-hand">
            <label class="form-check-label mouse-hand" for="flexRadioDefault2">
              <div :class="(propertyAdd.category == 'residential')? 'form-check rounded-pill classification-b button-bg': 'form-check rounded-pill classification-b'">
                <input class="form-check-input d-none" type="radio" @change="getTypes" v-model="propertyAdd.category" :disabled="categoryDisabled" value="residential" name="flexn" id="flexRadioDefault2">
                {{$t('addAd.title_44')}}
              </div>
            </label>
          </div>
          <div class="col-auto mouse-hand">
            <label class="form-check-label mouse-hand" for="agricultural">
              <div :class="(propertyAdd.category == 'agricultural')? 'form-check rounded-pill classification-b button-bg': 'form-check rounded-pill classification-b'">
                <input class="form-check-input d-none" type="radio" @change="getTypes" v-model="propertyAdd.category" :disabled="categoryDisabled" value="agricultural" name="flexn" id="agricultural">
                {{$t('addAd.title_79')}}
              </div>
            </label>
          </div>
          <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.category.$error">
            {{ validateMessage }}
          </div>
        </div>
        <div class="row py-2">
          <div v-if="!typeIdDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_49')}} <span class="stars">*</span> </label>
            <select @change="manageFields" v-model="propertyAdd.typeId" :disabled="typeIdDisabled" class="form-select input-style">
              <option  v-for="(type,index) in types" :key="index"  :value="type.id">{{type.name}}</option>
            </select>
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.typeId.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div v-if="showPropertyType" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_50')}} </label>
            <select v-model="propertyAdd.propertyType" name="" class="form-select input-style">
              <option :value="null" selected>{{$t('addAd.title_85')}}</option>
              <option value="families">{{$t('addAd.title_51')}}</option>
              <option value="singles">{{$t('addAd.title_52')}}</option>
            </select>
          </div>
        </div>

        <div class="row py-2">
          <div v-if="!priceDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_55')}}</label>
            <input type="text" v-model="price" :disabled="priceDisabled" class="form-control input-style"
              maxlength="10" @input="formatNumber"
            >
          </div>

          <div v-if="!regionIdDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_57')}} <span class="stars">*</span></label>
            <select v-model="propertyAdd.regionId" :disabled="regionIdDisabled" @change="citiesList" class="form-select input-style">
              <option v-for="(region,index) in regions" :key="index" :value="region.id">{{ region.name }}</option>
            </select>
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.regionId.$error">
              {{ validateMessage }}
            </div>
          </div>
        </div>

        <div class="row py-2">
          <div v-if="!cityIdDisabled" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_58')}} <span class="stars">*</span></label>
            <select v-model="propertyAdd.cityId" :disabled="cityIdDisabled" @change="neighborhoodsList" @click.prevent="checkRegions" class="form-select input-style" >
              <option v-for="(city,index) in cities" :key="index" :value="city.id"> {{ city.name }}</option>
            </select>
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.cityId.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div v-if="!neighborhoodIdDisabled" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_59')}} <span class="stars">*</span></label>
            <select v-model="propertyAdd.neighborhoodId" :disabled="neighborhoodIdDisabled" @click.prevent="checkNeighborhoods" class="form-select input-style" >
              <option v-for="(row,index) in rows" :key="index" :value="row.id">{{ row.name }}</option>
            </select>
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.neighborhoodId.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div v-if="!streetDisabled" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_60')}}</label>
            <input type="text" v-model="street" :disabled="streetDisabled" class="form-control input-style"
            >
          </div>

          <div class="col-12 col-md-6 pb-2" v-if="showPlotNumber && !plotNumberDisabled">
            <label for="" class="p-content">{{$t('addAd.plot_Number')}}</label>
            <input type="text" v-model="plotNumber" :disabled="plotNumberDisabled" class="form-control input-style"
            >
          </div>

          <div v-if="showBuildNumber && !buildNumberDisabled" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_61')}}</label>
            <input type="text" v-model="buildNumber" :disabled="buildNumberDisabled" class="form-control input-style"
              maxlength="10" @input="buildNumber = buildNumber.replace(/[^0-9]/g, '')"
            >
          </div>

          <!-- <div v-if="showFloorNumber" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_62')}}</label>
            <input type="text" v-model="floorNumber" class="form-control input-style"
              maxlength="10" @input="floorNumber = floorNumber.replace(/[^0-9]/g, '')"
            >
          </div> -->

          <!-- <div v-if="showFloorsCount" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_63')}}</label>
            <input type="text" class="form-control input-style" v-model="floorsCount"
              maxlength="10" @input="floorsCount = floorsCount.replace(/[^0-9]/g, '')"
            >
          </div> -->

          <!-- <div  v-if="showApartmentNumber" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_64')}}</label>
            <input type="text" v-model="apartmentNumber" class="form-control input-style"
              maxlength="10" @input="apartmentNumber = apartmentNumber.replace(/[^0-9]/g, '')"
            >
          </div> -->

          <div v-if="showAge && !ageDisabled" class="col-12 col-md-6 pb-2">
            <label for="" class="p-content">{{$t('addAd.title_65')}}</label>
            <!-- <input type="text" v-model="age" class="form-control"
              maxlength="10" @input="age = age.replace(/[^0-9]/g, '')"
            > -->
            <select v-model="age" :disabled="ageDisabled" class="form-select input-style" aria-label="Default select example">
              <option selected>{{$t('addAd.choose_Property_Age')}}</option>
              <option v-for="(val,indexage) in agesList" :key="indexage" :value="val.id">{{val.name}}</option>
            </select>
          </div>

          <div v-if="!areaDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_66')}}<span class="stars">*</span> </label>
            <input type="text" class="form-control input-style" v-model="propertyAdd.area" :disabled="areaDisabled"
              maxlength="10"  @input="propertyAdd.area = propertyAdd.area.replace(/[^0-9]/g, '')"
            >
            <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.area.$error">
              {{ validateMessage }}
            </div>
          </div>

          <div v-if="showMeterprice && !meterPriceDisabled" class="col-12 col-md-6">
            <label class="p-content" for="">{{$t('addAd.meterPrice')}}</label>
            <input type="text" class="form-control input-style" v-model="propertyAdd.meterPrice" :disabled="meterPriceDisabled"
              maxlength="10"  @input="propertyAdd.meterPrice = propertyAdd.meterPrice.replace(/[^0-9]/g, '')"
            >
          </div>

          <div v-if="showRoomsCount && !roomsCountDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_67')}}</label>
            <input type="text" class="form-control input-style" v-model="roomsCount" :disabled="roomsCountDisabled"
              maxlength="10" @input="roomsCount = roomsCount.replace(/[^0-9]/g, '')"
            >
          </div>

          <!-- <div v-if="showBathrooms" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_68')}}</label>
            <input type="text" class="form-control input-style" v-model="bathrooms"
              maxlength="10" @input="bathrooms = bathrooms.replace(/[^0-9]/g, '')"
            >
          </div> -->
        </div>

        <!-- <div class="row pt-2" v-if="showHalls">
          <div class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.numberHalls')}}</label>
            <input type="text" class="form-control input-style" v-model="halls"
              maxlength="10" @input="halls = halls.replace(/[^0-9]/g, '')"
            >
          </div>
        </div> -->

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-4" v-if="showFurnished">
            <label for="" class="p-content almarai-regular">{{$t('addAd.furnished')}}</label>
            <div class="row">
              <div class="col">
                <label for="True">
                  <div :class="(furnished) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="furnished  " class="form-check-input d-none" :value="true" id="True">
                    <span>{{$t('addAd.yes')}}</span>
                  </div>
                </label>
              </div>
              <div class="col">
                <label for="False">
                  <div :class="(!furnished) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="furnished" :value="false" class="form-check-input d-none" id="False">
                    <span>{{$t('addAd.no')}}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4" v-if="showSaudiBuildingCode && !saudiBuildingCodeDisabled">
            <label for="" class="p-content almarai-regular">{{$t('addAd.saudiBuildingCode')}}</label>
            <div class="row">
              <div class="col">
                <label for="true">
                  <div :class="(saudiBuildingCode) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="saudiBuildingCode" :disabled="saudiBuildingCodeDisabled" class="form-check-input d-none" :value="true" id="true">
                    <span>{{$t('addAd.yes')}}</span>
                  </div>
                </label>
              </div>
              <div class="col">
                <label for="false">
                  <div :class="(!saudiBuildingCode) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="saudiBuildingCode" :disabled="saudiBuildingCodeDisabled" :value="false" class="form-check-input d-none" id="false">
                    <span>{{$t('addAd.no')}}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div v-if="!hasObligationsDisabled" class="col-12 col-md-4">
            <label for="" class="p-content almarai-regular">{{$t('addAd.propertyObligation')}}</label>
            <div class="row">
              <div class="col">
                <label for="true-s">
                  <div :class="(hasObligations) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="hasObligations" :disabled="hasObligationsDisabled" class="form-check-input d-none" :value="true" id="true-s">
                    <span>{{$t('addAd.yes')}}</span>
                  </div>
                </label>
              </div>
              <div class="col">
                <label for="false-s">
                  <div :class="(!hasObligations) ? 'div-style text-center button-bg mouse-hand' : 'div-style text-center mouse-hand'">
                    <input type="radio" v-model="hasObligations" :disabled="hasObligationsDisabled" :value="false" class="form-check-input d-none" id="false-s">
                    <span>{{$t('addAd.no')}}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3">
          <div v-if="!frontIdDisabled" class="col">
            <label for="" class="p-content almarai-regular">{{$t('addAd.front')}}</label>
            <select v-model="frontId" :disabled="frontIdDisabled" class="form-select input-style" aria-label="Default select example">
              <option selected>{{$t('addAd.chooseInterface')}}</option>
              <option v-for="(val,indexF) in frontsList" :key="indexF" :value="val.id">{{val.name}}</option>
            </select>
          </div>
        </div>

        <div v-if="!latitudeDisabled && !longitudeDisabled" class="row">
          <div class="col">
            <div class="almarai-bold py-2">{{$t('addAd.title_69')}}</div>
            <div ref="myMap" style="width: 100%; height: 320px;"></div>
          </div>
        </div>

        <div class="row">
          <div v-if="!longitudeDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_70')}}</label>
            <input type="number" class="form-control input-style" v-model="longitude" :disabled="longitudeDisabled" />
          </div>

          <div v-if="!latitudeDisabled" class="col-12 col-md-6 pb-2">
            <label class="p-content" for="">{{$t('addAd.title_71')}}</label>
            <input type="number" class="form-control input-style" v-model="latitude" :disabled="latitudeDisabled" />
          </div>
        </div>

        <div class="row py-2">
          <div class="col-auto">
            <div type="button" class="btn-green" data-bs-toggle="modal" data-bs-target="#exampleModal">
              <i class="bi bi-file-earmark-plus"></i>
              <span class="mx-2">{{$t('addAd.title_72')}}</span>
            </div>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-auto" v-for="(item,index) in showFeatures" :key="index">
            <div>
              <img :src="MEDIA_URL+item.icon" class="max-width-28" alt="">
              {{item.name}} 
            </div>
          </div>
        </div>

        <div class="row pt-5 justify-content-center">
          <div class="col-9 col-md-3 mouse-hand">
            <div @click.prevent="nextStep" class="btn-green">
              {{$t('addAd.title_73')}}
            </div>
          </div>
        </div>

        <!-- <div class="row pt-5 justify-content-center">
          <div class="col-12 col-md-5">
            <div class="text-center" v-if="mLoader">
              <loader />
            </div>
            <div v-else class="row justify-content-center">
              <div class="col-12 col-md-6 text-center">
                <div v-if="!isFeatured" @click.prevent="advertisementCreate" class="form-control mouse-hand buttonStyle padding-style">
                  {{$t('addAd.title_77')}}
                </div>
                <div v-else @click.prevent="paymentFN" class="form-control mouse-hand buttonStyle padding-style">
                  {{$t('addAd.title_77')}}
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!--end: Property Data Add-->

    <!--begin: Advertisement details-->
    <div class="row" v-if="form == 4" >
      <div class="col">
        <div class="row justify-content-center" v-if="hasError">
          <div class="col-10 col-sm-5 text-center">
            <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span @click.prevent="prevStep" class="mouse-hand">
              <i class="fa-solid fa-arrow-right"></i>
            </span>
            <div class="py-2">
              <h5 class="font-20 almarai-bold" >{{$t('addAd.title_74')}}</h5>
            </div>
          </div>
        </div>

        <div class="row py-2">
          <!-- <div v-if="!purposeDisabled" class="col-12 col-md-6">
            <label class="p-content" for="">{{$t('addAd.title_45')}} <span class="stars">*</span> </label>
            <select v-model="purpose" :disabled="purposeDisabled" name="" class="form-select input-style">
              <option value="for_sale">{{$t('addAd.title_46')}}</option>
              <option value="for_rent">{{$t('addAd.title_47')}}</option>
              <option value="for_investment">{{$t('addAd.title_48')}}</option>
            </select>
            <div class="error-feedback red-color fonttext-14" v-if="V$.purpose.$error">
              {{ validateMessage }}
            </div>
          </div> -->

          <div class="col-12 col-md-6 button-center">
            <label for="" class="p-content">{{$t('addAd.TypeAdvertisement')}}</label>
            <select v-model="isFeatured" class="form-select input-style" aria-label="Default select example">
              <option selected>{{$t('addAd.choose_type_Ad')}}</option>
              <option :value="true"> {{$t('addAd.FeaturedAd')}} {{ featuredAdPrice }} {{$t('addAd.real')}} 
              </option>
              <option v-if="!normalPrice" :value="false">{{$t('addAd.regular_Ad')}}</option>
              <option v-if="normalPrice" :value="false">{{$t('addAd.regular')}} {{normalPrice}} {{$t('addAd.real')}}</option>
            </select>
          </div>
          <div class="col-12 col-md-6 content-end">
            <div class="form-check check-style">
              <label class="form-check-label show" for="checkDefault">
                <input @change="totalValue" v-model="checkbanner" class="checkBox form-check-input radio" type="checkbox" id="checkDefault">
                <span class="mx-4 almarai-bold">{{$t('billboardOpposite')}}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="row" v-if="checkbanner">
          <div class="col-12 col-md-6 content-end">
            <select @change="bannerPriceFN" v-model="bannerSizes" class="form-control input-style">
              <option :value="null">{{ $t('chooseBoard_size') }}</option>
              <option v-for="(banner,indx) in bannerSizesArray" :key="indx" :value="banner.id">{{ banner.name }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="p-content">{{$t('mobileNumber_displayed')}}</label>
            <input v-model="bannerMobile" type="text" class="form-control input-style"
              maxlength="10" @input="bannerMobile = bannerMobile.replace(/[^0-9]/g, '')"
              :placeholder="$t('addAd.placeholdermobileNumber')"
            >
            <div class="error-feedback" v-if="V$.bannerMobile.$error">
              {{ validateMessage }}
            </div>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-12" v-if="isFeatured == false && !normalPrice">
            <div class="row py-3">
              <div class="col">
                <div class="card Free">
                  <div class="card-body">
                    <div class="row">
                      <div class="col content-center text-center">
                        <span class="text-free">{{$t('addAd.Disclaimer')}} </span>
                        <div class="almarai-bold"> {{$t('addAd.service')}}<br>{{$t('addAd.service_2')}}</div>
                      </div>
                      <div class="col-auto img_Free">
                        <img src="assets/images/Frame-Free.png" class="width-104" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3 justify-content-center">
          <div class="col-12 col-md-5">
            <div class="text-center" v-if="mLoader">
              <loader />
            </div>
            <div v-else class="row justify-content-center">
              <div class="col-9 col-md-6 text-center">
                <div v-if="!isFeatured && !normalPrice && !bannerPrice" @click.prevent="advertisementCreate" class="btn-green">
                  {{$t('addAd.title_77')}}
                </div>
                <div v-else @click.prevent="paymentFN" class="btn-green">
                  {{$t('addAd.title_77')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end: Advertisement details-->

    <!--begin: Payment of fees-->
    <!-- <div class="row d-none">
      <div class="col">
        <div class="row">
          <div class="col">
            <span class="mouse-hand" @click.prevent="prevFour">
              <i class="fa-solid fa-arrow-right"></i>
            </span>
            <div class="py-2">
              <h5 class="almarai-bold ">دفع الرسوم</h5>
            </div>
            <div class="p-content">سعر لاعلان لمدة شهر (ترخيصك الاعلاني مجانا)</div>
            <div class="py-2">
              <h4 class="almarai-bold ">50 ريال فقط!</h4>
            </div>
          </div>
        </div>

        <div class="row py-2">
          <div class="col">
            <label class="p-content" for="">كود الخصم</label>
            <input type="text" class="form-control input-style" placeholder="ارفق كود خصم الخاص بك">
          </div>
        </div>

        <div class="row py-2">
          <div class="col-6 col-md-6">
            <div class="almarai-bold ">اختر طريقة الدفع</div>
          </div>
          <div class="col-6 col-md-6 text-start">
            <div class="orange-font">
              <i class="fa-solid fa-plus"></i>
              <span class="mx-2">اضافةبطاقة جديدة</span>
            </div>
          </div>
        </div>

        <div class="row py-2">
          <div class="col">
            <div class="form-check mb-2 input-style position-R">
              <input class="form-check-input check-radio" name="flexRadioDefault" id="mmm" type="radio" >
              <label class="form-check-label w-100" for="mmm" >
                <img src="/assets/images/empty-wallet.png" alt=""> 
                <span class="mx-2">المحفظة (1300 ريال)</span>
              </label>
            </div>
            <div class="form-check mb-2 input-style position-R">
              <input class="form-check-input check-radio" type="radio" id="flexRadioDefault1" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="flexRadioDefault1" >
              <img src="/assets/images/Frame 39.png" alt="">
              <span class="mx-2"> أبل باي</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="stc" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="stc" >
                <img src="/assets/images/Frame_40.png" alt=""> 
                <span class="mx-2">أس تي سي باي</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="visa" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="visa" >
                <img src="/assets/images/Frame_41.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="mada" type="radio" name="flexRadioDefault">
              <label class="form-check-label w-100" for="mada" >
                <img src="/assets/images/Frame_42.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="flexRadio" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="flexRadio">
                <img src="/assets/images/Frame_43.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
          </div>
        </div>

        <div class="row py-2 justify-content-center mt-5">
          <div class="col-12 col-md-8">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <button @click.prevent="stepFive" class="form-control buttonStyle rounded-pill">
                  التالي
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end: Payment of fees-->

    <!--begin:form success-->
    <div v-if="form == 5"  class="row">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('formSuccess.title_1')}}</h4>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col text-center">
            <span class="p-content">{{$t('formSuccess.title_2')}}</span> <br>
            <span class="p-content">{{$t('formSuccess.title_3')}}</span>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-9 col-md-5 btn-green">
            <router-link to="/">
              <div class="text-white">{{$t('formSuccess.title_4')}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!--begin:Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog max-w">
        <div class="modal-content">
          <button type="button" class="btn-close p-3"  data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="modal-body">
            <!--begin:Property Features-->
            <div class="row" v-for="(feature ,index) in featuresList" :key="index">
              <span class="almarai-bold py-2">{{feature.category }} </span>
              <div class="col-6 col-md-4 col-lg-4  button-center py-2" v-for="(feature ,index) in featuresList[index].features" :key="index" >
                <div class="form-check p-0 d-flex">
                  <input class="form-check-input mx-2" @change="selectedFeatures" type="checkbox" v-model="features" :value="feature.id" :id="feature.id">
                  <label class="form-check-label" :for="feature.id">
                    <img :src="MEDIA_URL+feature.icon" class="max-width-28" alt="">
                    <span class="mx-1 fonttext-14"> {{feature.name }}</span>
                  </label>
                </div>
              </div>
            </div>
            <!--end: Property Features-->
          </div>
          <div class="modal-footer">
            <button type="button" class=" ms-auto features-button" data-bs-dismiss="modal">{{$t('addAd.title_78')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal -->

    <!-- begin:payment_advertisementCreate -->
    <!-- <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="d-flex">
            <button type="button" id="closeModal" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
          </div>
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 mouse-hand">
                <div class="form-check input-style position-R">
                  <label for="visa" class="d-block">
                    <input class="form-check-input check-radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 mouse-hand">
                <div class="form-check input-style position-R">
                  <label for="radioDefault1" class="d-block">
                    <input class="form-check-input check-radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="row pt-5">
              <div class="col mouse-hand" @click.prevent="payAdvertisementCreate">
                <div class="buttonStyle padding-style almarai-bold form-control">{{$t('wallet.title_15')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- begin:payment_advertisementCreate -->


    <!-- begin:payment_advertisementCreate -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <!-- <span v-if="isFeatured"  class="mx-2 gray-color almarai-bold">{{featuredAdPrice+bannerPrice}}</span>
                    <span v-else class="mx-2 gray-color almarai-bold">{{normalPrice+bannerPrice}}</span> -->
                    <span class="mx-2 gray-color almarai-bold"> {{ finalPrice }} </span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand show">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand show">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-8 text-center">
                <div @click.prevent="payAdvertisementCreate" class="form-control btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:payment_advertisementCreate -->

    <!--begin:addAd_WalletBalance -->
    <button type="button"  id="addAd_WalletBalance" class="d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance"></button>
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeAdDetails" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{ finalPrice }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-11 col-md-6 text-center" @click.prevent="advertisementCreate">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:addAd_WalletBalance -->


    <!-- begin:documentPayment-->
    <button type="button"  id="documentPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#documentModal">
      </button>
    <div class="modal fade" id="documentModal" tabindex="-1" aria-labelledby="documentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModalDoc" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModalDoc" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="totalCost">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{(hasCoupon)? newDiscount : totalCost}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-7 text-center">
                <div @click.prevent="paymentMethod" class="form-control  almarai-bold btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:documentPayment-->

    <!--begin:documentPayment_WalletBalance -->
    <button type="button"  id="popup_WalletBalanceBtn" class="d-none" data-bs-toggle="modal" data-bs-target="#walletdocument"></button>
    <div class="modal bg-color-B" tabindex="-1" id="walletdocument">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{ USER_WALLET_BALANCE }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{totalCost}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <del>{{totalCost}}</del>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{ totalPrice }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col text-center" @click.prevent="documentedCreate">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:documentPayment_WalletBalance -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->


    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal bg-modal" id="selectNeighborhoods" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('cityFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="exit" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Nafath modal -->
    <button type="button" class="d-none" id="nafathBtnId" data-bs-toggle="modal" data-bs-target="#nafathModal">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade modal-sm" id="nafathModal" tabindex="-1" aria-labelledby="nafathModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="nafathModalLabel">{{ $t('nafath.cardTitle') }}</h1>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          </div>
          <div class="modal-body">{{ $t('nafath.mustVerify') }}</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-bs-dismiss="modal" @click="goToNafath"><i class="fa-solid fa-house-circle-check"></i> {{$t('nafath.linkTitle')}}</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('nafath.notNow') }}</button>
          </div>
        </div>
      </div>
    </div>

    <!--begin:modal login-->
    <div class="modal bg-modal" tabindex="-1" id="mustLoginProperty">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click.prevent="closeingFN">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="loginTitle">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="fontGray-73 mb-1 pt-1">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 mb-2">
                <router-link to="/login">
                  <button class="form-control btn-green">
                    {{$t("formLogin.title_4")}}
                  </button>
                </router-link>
              </div>
              <div class="col-12 col-md-8 pt-1">
                <router-link to="/register">
                  <button class="form-control btn-black">
                    {{ $t("formLogin.title_5") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->

    <!-- Modal:begin couponPopup -->
    <button type="button" id="coupon" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#couponModal">
    </button>
    <div class="modal fade" id="couponModal" tabindex="-1" aria-labelledby="couponModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content br-radius-24">
          <div class="modal-body text-center">
            <div><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
            <h6 v-if="value" class="pt-3"><span class="ms-1">{{$t('maintenances.title_9')}}</span> {{value.amount}} {{(value.discountType == "percentage" )? '%' : $t('maintenances.title_22') }}</h6>
            <p>{{$t('maintenances.title_20')}}</p>
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <div type="button" class="btn-green" data-bs-dismiss="modal">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Datepicker from 'vue3-datepicker';

export default {
  name: "PropertycreateRega",
  setup () {
    return { V$: useVuelidate() }
  },
  data(){
    return {
      paymentLoading: false,
      hasError: false,
      message: "",
      form: 1,
      brokerAd: "",
      ownerType: "",
      agentData: "",
      validateMessage: this.$t('validateMessage'),
      baiscOwner: { ownerIdentity: null, ownerDOB: null, ownerPhone: "" },
      baiscAgent: {
        ownerIdentity: null, ownerDOB: null, agentIdentity: null, agentDOB: null,
        agencyNumber: "", agentMobile: "",
      },
      receiptNumber: "",
      receiptDate: null,
      agencyDate: null,
      
      
      propertyAdd: {
        category: "", typeId: null, propertyType: null, title: "", area: null,
        description: "", regionId: null, cityId: null, neighborhoodId: null, meterPrice: null,
      },
      aD_duration: { durations: [] },
      broker: { falLicense: "", adLicenseNumber: "", ownerDOB: null, ownerPhone: "",
        agentIdentity: null, agencyNumber: "", agentMobile: "", agentDOB: null, ownerIdentity: null,
      },
      purpose: "",
      price: 0,
      street: "",
      buildNumber: "",
      floorNumber: 0,
      floorsCount: 0,
      age: 0,
      apartmentNumber: 0,
      roomsCount: 0,
      bathrooms: 0,
      isFeatured: false,
      features: [],
      regions: [],
      featuresList: [],
      types: [],      
      typesList: [],      
      isLoading: false,
      agencyPhoto: [],
      receiptImage: [],
      latitude: 0,
      longitude: 0,
      mediaList: [],
      mediaIds: [],
      mediaLoader: false,
      mLoader: false,
      cities: [],
      rows:[],
      step: "",
      fullName:"",
      mobile: "",
      alertSuccess: false,
      successMessage:"",
      ErrorAlert: false,
      agentError: false,
      brokerError: false,
      documentLoading: false,
      userLang: 'ar',
      errorNumber: 0,
      showBuildNumber: false,
      showFloorsCount : false,
      showFloorNumber: false,
      showApartmentNumber: false,
      showRoomsCount: false,
      showBathrooms: false,
      showMeterprice: false,
      showAge : false,
      showPropertyType: false,
      showFeatures: [],
      paymentGate: '',
      maxDate: null,
      lowerDate: null,
      today: null,
      agesList: [],
      featuredAdPrice: null,
      furnished: null,
      hasObligations: null,
      saudiBuildingCode: true,
      frontId: null,
      frontsList: [],
      plotNumber: "",
      showFurnished: false,
      showSaudiBuildingCode: null,
      showPlotNumber: false,
      halls: 1,
      showHalls : false,
      options: [],
      packageId: null,
      paymentGate: "",
      totalCost: 0,
      min_loader: false,
      remainingBalance: null,
      yesterday: new Date(),
      maxDateAgent: null,
      lawyerPrice: null,
      error: false,
      showRegaValidation: false,
      selectedBtn: null,
      adLicenseNumber: null,
      idType: null,
      advertiserId: null,
      checkerDisabled: false,
      checkerError: false,
      checkerId: null,
      // disabled items 
      regionIdDisabled: false,
      cityIdDisabled: false,
      neighborhoodIdDisabled: false,
      receiptNumberDisabled: false,
      streetDisabled: false,
      buildNumberDisabled: false,
      latitudeDisabled: false,
      longitudeDisabled: false,
      priceDisabled: false,
      roomsCountDisabled: false,
      hasObligationsDisabled: false,
      purposeDisabled: false,
      saudiBuildingCodeDisabled: false,
      plotNumberDisabled: false,
      areaDisabled: false,
      meterPriceDisabled: false,
      ownerIdentityDisabled: false,
      agentIdentityDisabled: false,
      ownerPhoneDisabled: false,
      agentMobileDisabled: false,
      agencyNumberDisabled: false,
      categoryDisabled: false,
      typeIdDisabled: false,
      frontIdDisabled: false,
      ageDisabled: false,
      falLicense: null,
      normalPrice: null,
      bannerSizesArray: [],
      bannerSizes: null,
      bannerMobile: "",
      bannerPrice: 0,
      checkbanner: false,
      finalPrice: 0,
      discount: null,
      hasCoupon: false,
      newDiscount: null,
      discountPercentage: null,
      value: {},
      totalPrice: null,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL','USER_WALLET_BALANCE', 'GET_USER_DATA', 'GET_USER','ISLOADING'])
  },
  components: {
    Datepicker,
  },
  validations () {
    return {
      baiscOwner: {
        ownerIdentity: {required}, ownerDOB: {required}, ownerPhone: {required}
      },
      baiscAgent: {
        agentIdentity: {required}, 
        agencyNumber: {required}, agentMobile: {required}
      },
      propertyAdd: {
        category: {required}, typeId:{required},  
        title: {required}, area: {required}, description: {required},  regionId: {required},
        cityId: {required}, neighborhoodId: {required}
      },
      aD_duration: { durations: {required} },

      broker: { falLicense:{required}, adLicenseNumber: {required},
        agentMobile: {required},
      },

      fullName:{required},
      mobile: {required},
      receiptNumber: {required},
      purpose: {required},
      packageId: {required},
      bannerMobile: {required},
    }
  },
  methods: {
    getInitialData(){
      this.hasError = false;
      this.isLoading = true;
      this.$http.get("/api/properties/init").then(res => {
        // console.log(res);
        this.regions = res.data.regionsList;
        this.featuresList = res.data.featuresList;
        this.typesList = res.data.typesList;
        this.durations = res.data.durations;
        this.agesList = res.data.agesList;
        this.featuredAdPrice = res.data.featuredAdPrice;
        this.frontsList = res.data.frontsList;
        this.lawyerPrice = res.data.lawyerPrice;
        this.normalPrice = res.data.normalPrice;
        this.bannerSizesArray = res.data.bannerSizes;
        this.getLocation();
        this.initialGoogleMap();
        // this.priceLists();
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },
    
    

    advertisementCreate() {
      this.hasError = false;
      this.mLoader = true;
      let owner = {
        ownerType: this.ownerType,
        receiptNumber: this.receiptNumber,
        receiptDate: this.receiptDate,
        agencyDate: this.agencyDate,
        adLicenseNumber: this.adLicenseNumber,
        falLicense: this.falLicense,
      };
      let property = {
        ...this.propertyAdd, street: this.street, buildNumber: this.buildNumber, 
        floorsCount: parseInt(this.floorsCount), floorNumber: parseInt(this.floorNumber), latitude: this.latitude,
        apartmentNumber: parseInt(this.apartmentNumber), price: parseInt(this.price), longitude: this.longitude,
        roomsCount: parseInt(this.roomsCount), bathrooms: parseInt(this.bathrooms), age: parseInt(this.age),
        isFeatured: this.isFeatured, features: this.features, adDuration: this.aD_duration.durations, 
        mediaIds: this.mediaIds, furnished: this.furnished, hasObligations:this.hasObligations, purpose:this.purpose,
        saudiBuildingCode: this.saudiBuildingCode, frontId:this.frontId, plotNumber: this.plotNumber, halls:this.halls,
        bannerSizeId:this.bannerSizes, bannerMobile:this.bannerMobile
      }
      if(property.area){
        property.area = parseInt(property.area);
      }

      if(property.halls){
        property.halls = parseInt(property.halls);
      }
      if(property.meterPrice){
        property.meterPrice = parseInt(property.meterPrice);
      }

      if(this.ownerType == "owner"){
        owner.ownerIdentity = parseInt(this.baiscOwner.ownerIdentity);
        owner.ownerDOB = this.baiscOwner.ownerDOB;
        owner.ownerMobile = this.baiscOwner.ownerPhone; 
      }
      if(this.ownerType == "agent"){
        owner.ownerIdentity = parseInt(this.baiscAgent.ownerIdentity);
        owner.ownerDOB = this.baiscAgent.ownerDOB;
        owner.agentIdentity = parseInt(this.baiscAgent.agentIdentity);
        owner.agentDOB = this.baiscAgent.agentDOB;
        owner.agentMobile = this.baiscAgent.agentMobile;
        owner.agencyNumber = this.baiscAgent.agencyNumber;
      }
      if(this.ownerType == "broker"){
        // owner.ownerIdentity  = parseInt(this.broker.ownerIdentity);
        // owner.ownerDOB  = this.broker.ownerDOB;
        // owner.ownerMobile = this.broker.ownerPhone;
        // owner.agentIdentity = parseInt(this.broker.agentIdentity);
        // owner.agentDOB = this.broker.agentDOB;
        // owner.agencyNumber = this.broker.agencyNumber;
        owner.agentMobile = this.broker.agentMobile;
      }
      const formData = new FormData();
      formData.append("owner", JSON.stringify(owner));
      formData.append("property", JSON.stringify(property));
      formData.append("paymentGate", this.paymentGate);
      formData.append("checkerId", this.checkerId);
      if(this.agencyPhoto){
        for(let file =0; file < this.agencyPhoto.length; file++){
          formData.append("agencyImage", this.agencyPhoto[file]);
        }
      }
      if(this.receiptImage){
        for(let rf =0; rf < this.receiptImage.length; rf++){
          formData.append("receiptImage", this.receiptImage[rf]);
        }
      }

      this.$http.post("/api/properties/create",formData).then(res => {
        // console.log(res);
        if( this.isFeatured && res.data.paymentUrl ){
          window.location.href= res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('closeAdDetails').click();
          }
          this.form = 5;
          this.mLoader = false;
        }
      }).catch (err => {
        // console.log(err);
        this.mLoader = false;
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
        this.closeOpendPopup();
      })
    },

    async nextStep(){
      this.hasError = false;
      this.ErrorAlert = false;
      this.agentError = false;
      this.brokerError = false;

      if(this.form == 2 && this.ownerType == 'owner'){
        const isValid = await this.V$.baiscOwner.$validate() || this.V$.receiptNumber.$validate();
          if(this.baiscOwner.ownerIdentity && ((this.baiscOwner.ownerIdentity.substring(0, 1) != 1 && this.baiscOwner.ownerIdentity.substring(0, 1) != 2)  || `${this.baiscOwner.ownerIdentity}`.length !=10)){
            this.message =  this.$t("ownerIdentity_Message");
            this.ErrorAlert = true;
            window.scroll(0,0);
            return false;
          }

          if(this.baiscOwner.ownerPhone.trim().length !=10 || !this.baiscOwner.ownerPhone.startsWith('05')){
            this.message = this.$t('ownerPhone_Message');
            this.ErrorAlert = true;
            window.scroll(0,0);
            return false;
          }

          if(this.receiptNumber.trim().length < 10 || this.receiptNumber.trim().length > 16 ){
            this.message =  this.$t('receiptNumber_Message');
            this.ErrorAlert = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        if(!isValid){
          return false;
        }
      }

      if(this.form == 2 && this.ownerType == 'agent'){
        const isValid = await this.V$.baiscAgent.$validate();

        if(this.baiscAgent.agentIdentity && ((this.baiscAgent.agentIdentity.substring(0,1) !=1 && this.baiscAgent.agentIdentity.substring(0,1) !=2) || `${this.baiscAgent.agentIdentity}`.length !=10)){
          this.message =  this.$t('agentIdentity_Message');
          this.agentError = true;
          window.scroll(0,0);
          return false;
        }

        // if(this.baiscAgent.ownerIdentity && ((this.baiscAgent.ownerIdentity.substring(0, 1) != 1 && this.baiscAgent.ownerIdentity.substring(0, 1) != 2) || `${this.baiscAgent.ownerIdentity}`.length !=10)){
        //   this.message = this.$t("ownerIdentity_Message");
        //   this.agentError = true;
        //   window.scroll(0,0);
        //   return false;
        // }

        if(this.receiptNumber.trim().length < 10 || this.receiptNumber.trim().length > 16 ) {
          this.message = this.$t('receiptNumber_Message');
          this.agentError = true;
          window.scroll(0,0);
          return false;
        }

        if(this.baiscAgent.agencyNumber.trim().length !=10){
          this.message =  this.$t('agencyNumber_Message');
          this.agentError = true;
          window.scroll(0,0);
          return false;
        }
        
        if(this.baiscAgent.agentMobile.trim().length !=10 || !this.baiscAgent.agentMobile.startsWith('05')){
          this.message = this.$t('agentMobile_Message');
          this.agentError = true;
          window.scroll(0,0);
          return false;
        }
        
        if(!isValid){
          window.scroll(0,0);
          return false;
        }
      }

      if(this.form == 3) {
        const isValid = await this.V$.propertyAdd.$validate();
        if(this.propertyAdd.title.length < 5 ){
        this.message = this.$t('propertyAdd_Title');
        this.hasError = true;
        window.scroll(0,0);
        return false;
        }

        if(!isValid) {
          window.scroll(0,0);
          return false;
        }
      }
      if(this.form == 4) {
        const isValid = await this.V$.aD_duration.$validate();
        if(!isValid) {
          return false;
        }
      }
      if(this.ownerType == "broker" && this.form == "brokerAd") {
        const isValid = await this.V$.broker.$validate();

        if(this.receiptNumber.trim().length < 10 || this.receiptNumber.trim().length > 16 ) {
          this.message = this.$t('receiptNumber_Message');
          this.brokerError = true;
          window.scroll(0,0);
          return false;
        }
        // if(this.broker.ownerPhone.trim().length !=10) {
        //   this.message = this.$t('ownerPhone_Message');
        //   this.brokerError = true;
        //   window.scroll(0,0);
        //   return false;
        // }
        
        // if(this.broker.ownerIdentity && ((this.broker.ownerIdentity.substring(0,1) !=1 && this.broker.ownerIdentity.substring(0,1) !=2) || this.broker.ownerIdentity.length !=10)) {
        //   this.message = this.$t('ownerIdentity_Message');
        //   this.brokerError = true;
        //   // window.scroll(0,0);
        //   window.scrollTo({ top:0, behavior:'smooth'});
        //   return false;
        // }
        // if(this.broker.agentIdentity && ((this.broker.agentIdentity.substring(0,1) !=1 && this.broker.agentIdentity.substring(0,1) !=2) || this.broker.agentIdentity.length !=10)) {
        //   this.message = this.$t('agentIdentity_Message');
        //   this.brokerError = true;
        //   // window.scroll(0,0);
        //   window.scrollTo({ top:0, behavior:'smooth'});
        //   return false;
        // }
        if(this.broker.agentMobile.trim().length !=10 || !this.broker.agentMobile.startsWith('05')) {
          this.message = this.$t('brokersMobile');
          this.brokerError = true;
          window.scroll(0,0);
          return false;
        }
        if(!isValid) {
          return false;
        }
        this.form = 2;
      }

      this.form += 1;
    },

    prevStep(){
      if(this.ownerType == "broker"){
        this.form = 2;
      }
      this.form = (this.form > 1)? this.form - 1 : 1;
      if(this.form == 1 && this.showRegaValidation)
        this.showRegaValidation = false;
      this.getInitialData();
    },

    ownerFN(){
      const modalBtn = document.getElementById('nafathBtnId');
      if(this.GET_USER_DATA.nafathStatus != 'COMPLETED' && modalBtn){
        modalBtn.click();
      }else{
        this.ownerType = 'owner';
        this.form = 2;
      }
    },

    agentFN(){
      this.ownerType = 'agent';
    },

    // restValue() {
    //   this.features = [];
    // },

    uploadFile(files) {
      this.agencyPhoto = [...files];
    },

    setReceiptImage(files) {
      this.receiptImage = [...files];
    },

    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++) {
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mediaFile = await this.$http.post("/api/media/upload",formData);
          if(mediaFile) {
            this.mediaIds.push(mediaFile.data.mediaId);
            this.mediaList.push({
              id: mediaFile.data.mediaId,
              path: mediaFile.data.filePath,
            })
          }
        } catch (err){
          [this.message , this.errorNumber] = this.$globalError(err ,true);
          this.hasError = true;
          window.scroll(0,0);
          this.mediaLoader = false;
        }finally {
          this.mediaLoader = false;
        }
      }
    },

    citiesList(){
      this.hasError = false;
      this.$http.get(`/api/cities/list/?regionId=${this.propertyAdd.regionId}`).then(res => {
        // console.log(res);
        this.cities = res.data.cities;
      }).catch (err => {
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    neighborhoodsList(){
      this.hasError = false;
      this.$http.get(`/api/neighborhoods/list/?cityId=${this.propertyAdd.cityId}`).then(res => {
        // console.log(res);
        this.rows = res.data.neighborhoods;
      }).catch(err => {
        [this.message , this.errorNumber] = this.$globalError(err ,true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },

    brokerAdvertisement(){
      const modalBtn = document.getElementById('nafathBtnId');
      if(this.GET_USER_DATA.nafathStatus != 'COMPLETED' && modalBtn){
        modalBtn.click();
      }else{
        this.form = 'brokerAd';
        this.ownerType = "broker";
      }
    },

    deleteImg(id, indx){
      swal({
        title: this.$t('image_Title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, indx));
    },
    deleteMedia(id, indx){
      this.$http.delete("/api/media/delete/"+id).then(res => {
        this.mediaList.splice(indx, 1);
        this.mediaIds.splice(indx, 1);
        swal(this.$t('success_Message'));
      })
    },
    documentationFN(){
      this.step = 'documentation';
      this.form = ""
    },
    prevDocument(){
      this.form = 1;
      this.step = '';
    },

    closeOpendPopup(){
      const modalDiv1 = document.getElementById('popup_WalletBalance');
      if(modalDiv1 && modalDiv1.style.display == 'block'){
        document.getElementById('closeWalletBalance').click();
      }
      const modalDiv2 = document.getElementById('documentModal');
      if(modalDiv2 && modalDiv2.style.display == 'block'){
        document.getElementById('closeModalDoc').click();
      }
      const popup_addAd = document.getElementById('addAd_WalletBalance');
      if(popup_addAd && popup_addAd.style.display == 'block'){
        document.getElementById('closeAdDetails').click();
      }
    },

    documentedCreate(){
      this.hasError = false;
      this.documentLoading = true;
      this.min_loader = true;
      this.alertSuccess = false;
      if(this.mobile.trim().length != 10 && !this.mobile.startsWith('05')){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      this.$http.post("/api/propertyDoc/create",{
        name: this.fullName,
        mobile: this.mobile,
        paymentGate: this.paymentGate,
        priceId: this.packageId,
      }).then(res => {
        // console.log(res);.
        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            this.$store.dispatch('checkUser');
            document.getElementById('closeWalletBalance').click();
          }
          this.step = 'formSuccess'
        }
        this.fullName = '';
        this.mobile = '';
        this.packageId = null;
        window.scroll(0,0);
        this.documentLoading = false;
        this.min_loader = false;
        this.closeOpendPopup();
        setTimeout(()=> {
          this.alertSuccess = false;
        },800);
      }).catch(err => {
        // console.log(err);
        this.documentLoading = false;
        this.min_loader = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
        this.closeOpendPopup();
      });
    },

    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    initMap(allowEdit=true){
      if(this.latitudeDisabled || this.longitudeDisabled)
        return;
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(allowEdit), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: allowEdit, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
        this.cityByLatFN();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
        this.cityByLatFN();
      });

      if(!allowEdit){
        google.maps.event.clearInstanceListeners(this.map);
      }
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap(true);
      }
    },
    lettersOnly(e) {
      e.target.value = e.target.value.replace(/[^a-zA-Z\u0600-\u06FF\s]/g, '');
      this.fullName = e.target.value;
    },

    getTypes(editFields=true){
      // console.log(this.propertyAdd.category);
      this.showBuildNumber = false;
      this.showFloorsCount = false;
      this.showFloorNumber = false;
      this.showApartmentNumber = false;
      this.showRoomsCount = false;
      this.showBathrooms = false;
      this.showAge = false;
      this.showPropertyType = false;
      this.showFurnished = false;
      this.showSaudiBuildingCode = false;
      this.showPlotNumber = false;
      this.showHalls = false;
      this.showMeterprice = false;
      this.showMeterprice = null;
      
      if(editFields){
        this.propertyAdd.typeId = null;
        this.buildNumber = '';
        this.floorsCount = null;
        this.floorNumber = null;
        this.apartmentNumber = null;
        this.roomsCount = null;
        this.bathrooms = null;
        this.age = null;
        this.propertyAdd.propertyType = null;
        this.furnished = null;
        this.saudiBuildingCode = null;
        this.plotNumber = "";
        this.halls = null;
      }

      let typesArray = [];
      for(let i=0; i < this.typesList.length; i++) {
        if(this.typesList[i].category == this.propertyAdd.category) {
          typesArray.push(this.typesList[i]);
        }
      }
      this.types = typesArray;
      
    },

    manageFields(){
      // console.log(this.propertyAdd.typeId);
      this.showBuildNumber = false;
      this.showFloorsCount = false;
      this.showFloorNumber = false;
      this.showApartmentNumber = false;
      this.showRoomsCount = false;
      this.showBathrooms = false;
      this.showAge = false;
      this.showPropertyType = false;
      this.showFurnished = false;
      this.showSaudiBuildingCode = false;
      this.showPlotNumber = false;
      this.showHalls = false;
      this.showMeterprice = false;


      this.buildNumber = '';
      this.floorsCount = null;
      this.floorNumber = null;
      this.apartmentNumber = null;
      this.roomsCount = null;
      this.bathrooms = null;
      this.age = null;
      this.propertyAdd.propertyType = null;
      this.furnished = null;
      this.saudiBuildingCode = null;
      this.plotNumber = "";
      this.halls = null;
      this.showMeterprice = null;

      if(this.propertyAdd.typeId){
        for(let i=0; i < this.typesList.length; i++) {
          if(this.typesList[i].id == this.propertyAdd.typeId) {
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('buildNumber') != -1){
              this.showBuildNumber = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('floorsCount') != -1){
              this.showFloorsCount = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('floorNumber') != -1){
              this.showFloorNumber = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('apartmentNumber') != -1){
              this.showApartmentNumber = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('roomsCount') != -1){
              this.showRoomsCount = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('bathrooms') != -1){
              this.showBathrooms = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('age') != -1){
              this.showAge = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('propertyType') != -1){
              this.showPropertyType = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('furnished') != -1){
              this.showFurnished = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('saudiBuildingCode') != -1){
              this.showSaudiBuildingCode = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('plotNumber') != -1){
              this.showPlotNumber = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('halls') != -1){
              this.showHalls = true;
            }
            if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('meterPrice') != -1){
              this.showMeterprice = true;
            }
          }
        }
      }
      // console.log(this.showBuildNumber);
      // console.log(this.showFloorsCount);
      // console.log(this.showFloorNumber);
      // console.log(this.showApartmentNumber);
      // console.log(this.showBathrooms);
      // console.log(this.showBuildNumber);
      // console.log(this.showAge);
      // console.log(this.showPropertyType);
    },
    
    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },

    selectedFeatures(){
      this.showFeatures = [];
      for(let i=0; i< this.featuresList.length; i++){
        for(let f= 0; f< this.featuresList[i].features.length; f++){
          if(this.features.indexOf(this.featuresList[i].features[f].id) !=-1 ){
            this.showFeatures.push(this.featuresList[i].features[f]);
          }
        }
      }
    },
    
    onChange() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      this.today = yesterday;
      // this.today.setDate(this.today.getDate() - 1)
      // if (this.receiptDate > this.today) {
      //     alert('لا يمكن اختيار تاريخ بعد أمس')
      //   this.receiptDate = this.today;
      // }
      // console.log(this.today);
      
    },

    formatNumber() {
      // امسح أي حروف غير أرقام
      let raw = this.price.replace(/,/g, "").replace(/\D/g, "");

      // لو فاضي — رجّعه
      if (!raw) {
        this.price = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.price = Number(raw).toLocaleString("en-US");
    },
    cityByLatFN(){
      this.$http.post('/api/cities/cityByLat',{
        longitude: this.longitude,
        latitude: this.latitude,
      }).then(res => {
        // console.log(res);
        if(res.data.region){
          this.propertyAdd.regionId = res.data.region.id;
          this.citiesList();
        }
        if(res.data.city){
          this.propertyAdd.cityId = res.data.city.id;
          this.neighborhoodsList();
        }
        if(res.data.neighborhood)
          this.propertyAdd.neighborhoodId = res.data.neighborhood.id;
      }).catch(err => {
        console.log(err);
      })
    },

    priceLists(){
      this.$http.get('/api/propertyDoc/priceOptions').then(res => {
        //console.log(res);
        this.options = res.data.options;
      }).catch(err => {
        console.log(err);
        
      })
    },

    paymentMethod(){
      if(this.paymentGate == 'online'){
        this.documentedCreate();
      }else{
        this.showPopup();
      }
    },

    payAdvertisementCreate(){
      if(this.paymentGate == 'online'){
        this.advertisementCreate();
      }else{
        this.WalletDetails();
      }
    },

    // Wallet details, add ad
    WalletDetails(){
      document.getElementById('closeModalDoc').click();
      if(this.isFeatured){
        this.finalPrice = this.featuredAdPrice + this.bannerPrice;
      }else{
        this.finalPrice = this.normalPrice + this.bannerPrice;
      }
      if(this.finalPrice > this.USER_WALLET_BALANCE) {
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        // console.log(this.finalPrice);
        this.remainingBalance = this.USER_WALLET_BALANCE - this.finalPrice;
        document.getElementById('addAd_WalletBalance').click();
      }
    },

    totalValue(){
      if(!this.checkbanner){
        this.bannerSizes = null;
        this.bannerMobile = null;
        this.bannerPrice = 0;
      }
      if(this.isFeatured){
        this.finalPrice = this.featuredAdPrice + this.bannerPrice;
      }else{
        this.finalPrice = this.normalPrice + this.bannerPrice;
      }
    },

    paymentFN(){
      if(this.checkbanner && !this.bannerMobile){
        this.message = this.$t('mobileNumber_required');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(this.checkbanner && (!this.bannerMobile.startsWith('05') || this.bannerMobile.trim().length != 10)){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(this.bannerMobile){
        this.message = '';
        this.hasError = false;
      }
      if(this.isFeatured){
        this.finalPrice = this.featuredAdPrice + this.bannerPrice;
      }else{
        this.finalPrice = this.normalPrice + this.bannerPrice;
      }
      
      document.getElementById('selectPayment').click();
    },

    async showPayment(){
      this.hasError = false;
      if(this.fullName == ""){
        const isValid = await this.V$.fullName.$validate();
        if(!isValid){
          window.scrollTo({top:0, behavior:'smooth'});
          return false;
        }
      }
      if(this.mobile == ""){
        const isValid = await this.V$.mobile.$validate();
        if(!isValid){
          window.scrollTo({top:0, behavior:'smooth'});
          return false;
        }
      }
      if(this.mobile.length != 10 || !this.mobile.startsWith('05')){
        this.message = this.$t('mobile_Message');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(this.packageId == null){
        const isValid = await this.V$.packageId.$validate();
        if(!isValid){
          window.scrollTo({top:0, behavior:'smooth'});
          return false;
        }
      }
      if(this.hasCoupon && this.value.discountType == 'percentage' && this.value.amount == 100){
        this.documentedCreate();
        return false;
      }
      document.getElementById('documentPayment').click();
    },

    selectedPackage(){
      this.options.map((e)=> {
        if(e.id == this.packageId){
          this.totalCost = e.price;
        }
      });
    },

    showPopup(){
      document.getElementById('closeModalDoc').click();
      if(this.totalCost > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        this.remainingBalance =  this.USER_WALLET_BALANCE - this.totalCost;
        document.getElementById('popup_WalletBalanceBtn').click();
      }
    },


    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },

    checkRegions(){
      if(!this.propertyAdd.regionId){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    checkNeighborhoods(){
      if(!this.propertyAdd.cityId){
        document.getElementById('selectNeighborhoods').style.display ='block';
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },
    exit(){
      document.getElementById('selectNeighborhoods').style.display ='none';
    },
    goToNafath(){
      this.$router.push('/nafath');
    },
    // handleInput() {
    //   this.error = !this.baiscOwner.ownerPhone.startsWith('05') 
    // }

    validationForm(userSelection){
      this.showRegaValidation = true;
      this.selectedBtn = userSelection;
    },

    checkLicense(){
      this.checkerError = false;
      this.checkerDisabled = true;
      if(!this.adLicenseNumber || !this.idType || !this.advertiserId){
        this.message = this.$t('addAd.allDataRequered');
        this.errorNumber = 0;
        this.checkerError = true;
        this.checkerDisabled = false;
        window.scroll(0,0);
        return;
      }

      this.$http.post("/api/properties/checkAd",{
        adLicenseNumber: this.adLicenseNumber,
        idType: this.idType,
        advertiserId: this.advertiserId,
      }).then(({data}) => {
        // console.log(data);
        if(!data.result.isValid){
          this.message = data.result.message;
          this.errorNumber = 0;
          this.checkerError = true;
          this.checkerDisabled = false;
          window.scroll(0,0);
          return;
        }
        this.ownerType = (this.idType == 1)? 'owner' : 'broker';
        this.checkerId = data.checkerId;
        const regaData = data.result.advertisement;
        if(data.region)
          this.propertyAdd.regionId = data.region.id;
        if(data.city)
          this.propertyAdd.cityId = data.city.id;
        if(data.neighborhood)
          this.propertyAdd.neighborhoodId = data.neighborhood.id;
        this.regionIdDisabled = true;
        this.cityIdDisabled = true;
        this.neighborhoodIdDisabled = true;
        this.citiesList();
        this.neighborhoodsList();
        this.broker.adLicenseNumber = this.adLicenseNumber;
        if(data.propertyType){
          this.propertyAdd.category = data.propertyType.category;
          this.categoryDisabled = true;
          this.propertyAdd.typeId = data.propertyType.id;
          this.typeIdDisabled = true;
          this.getTypes(false);
        }
        if(data.front){
          this.frontId = data.front.id;
          this.frontIdDisabled = true;
        }
        if(data.age){
          this.age = data.age.id;
          this.ageDisabled = true;
        }
        // fill data start 
        this.receiptNumber = regaData.deedNumber;
        this.receiptNumberDisabled = true;
        this.street = regaData.location.street;
        this.streetDisabled = true;
        this.buildNumber = regaData.location.buildingNumber;
        this.buildNumberDisabled = true;
        this.latitude = regaData.location.latitude;
        this.latitudeDisabled = true;
        this.longitude = regaData.location.longitude;
        this.longitudeDisabled = true;
        this.price = (regaData.landTotalPrice)? regaData.landTotalPrice : regaData.propertyPrice;
        this.priceDisabled = true;
        this.roomsCount = regaData.numberOfRooms ?? 0;
        this.roomsCountDisabled = true;
        this.hasObligations = regaData.isConstrained ?? false;
        this.hasObligationsDisabled = true;
        this.purpose = (regaData.advertisementType == 'بيع')? 'for_sale' : 'for_rent';
        this.purposeDisabled = true;
        this.saudiBuildingCode = (regaData.complianceWithTheSaudiBuildingCode)? true : false;
        this.saudiBuildingCodeDisabled = true;
        this.plotNumber = regaData.landNumber ?? 0;
        this.plotNumberDisabled = true;
        this.propertyAdd.area = (regaData.propertyArea)? parseFloat(regaData.propertyArea.toFixed(2)) : 0;
        this.areaDisabled = true;
        if(regaData.landTotalPrice){
          this.propertyAdd.meterPrice = regaData.propertyPrice;
          this.meterPriceDisabled = true;
        }
        this.baiscOwner.ownerIdentity = regaData.advertiserId;
        this.baiscAgent.ownerIdentity = regaData.advertiserId;
        this.ownerIdentityDisabled = true;
        this.baiscAgent.agentIdentity = regaData.advertiserId;
        this.agentIdentityDisabled = true;
        this.baiscOwner.ownerPhone = regaData.phoneNumber;
        this.ownerPhoneDisabled = true;
        this.baiscAgent.agentMobile = regaData.responsibleEmployeePhoneNumber ?? regaData.phoneNumber;
        this.broker.agentMobile = regaData.responsibleEmployeePhoneNumber ?? regaData.phoneNumber;
        this.agentMobileDisabled = true;
        this.baiscAgent.agencyNumber = regaData.brokerageAndMarketingLicenseNumber;
        this.falLicense = regaData.brokerageAndMarketingLicenseNumber;
        this.agencyNumberDisabled = true;
        // fill data end 
        this.checkerDisabled = false;
        this.initMap(false);
        this.form = 3;
      }).catch(err => {
        if(err.response && err.response.data && err.response.data.result){
          this.message = err.response.data.result.message;
          this.errorNumber = 0;
        }else{
          [this.message , this.errorNumber] = this.$globalError(err ,true);
        }
        this.checkerError = true;
        this.checkerDisabled = false;
        window.scroll(0,0);
      });
    },

    closeingFN() {
      document.getElementById("mustLoginProperty").style.display = "none";
    },

    poupLogin(){
      document.getElementById("mustLoginProperty").style.display = "block";
    },

    bannerPriceFN(){
      if(!this.bannerSizes){
        this.bannerPrice = 0;
      }else {
        for(let i=0; i < this.bannerSizesArray.length; i++){
          if(this.bannerSizes == this.bannerSizesArray[i].id){
            this.bannerPrice = this.bannerSizesArray[i].price;
          }
        }
      }
    },

    checkDiscount(){
      this.hasError = false;
      this.$http.post("/api/coupons/available",{
        coupon: this.discount,
        modelName: 'propertyDocs',
      }).then(res => {
        // console.log(res);
        this.value = res.data.row;
        this.discountPercentage = res.data.row;
        document.getElementById('coupon').click();
        if(this.value.discountType == 'percentage'){
          this.newDiscount = this.totalCost - ((this.totalCost * this.value.amount) /100);
          this.totalPrice = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          this.newDiscount = this.totalCost - this.value.amount;
          this.totalPrice = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
        this.hasCoupon = true;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.hasCoupon = false;
      });
    },
  },

  created(){
    this.ErrorAlert = false;
    if(this.GET_USER){
      this.priceLists();
    }
    this.getInitialData();
    this.maxDate = new Date();
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 10);
    this.maxDateAgent = new Date();
    this.maxDateAgent.setFullYear(this.maxDateAgent.getFullYear() -20);

    // this.baiscOwner.ownerDOB = this.maxDate;
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
    // if(window.getComputedStyle(document.getElementById("mobNavBtn"),null).getPropertyValue('display') == 'block' && window.getComputedStyle(document.getElementById("navbarNavDropdown"),null).getPropertyValue('display') == 'block'){
    //   document.getElementById("mobNavBtn").click();
    // };
    let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      this.yesterday = yesterday;
  },
}
</script>
